import React, { Suspense, lazy } from 'react';
const SalesPage = lazy(() => import('./pages/SalesPage').then(module => ({
  default: module.SalesPage
})));
export function App() {
  return <Suspense fallback={<div className="min-h-screen bg-[#0a0a12] flex items-center justify-center" data-id="element-1">
          <div className="flex flex-col items-center gap-4" data-id="element-2">
            <div className="w-10 h-10 border-4 border-red-500 border-t-transparent rounded-full animate-spin" data-id="element-3"></div>
            <p className="text-gray-400 text-sm uppercase tracking-widest font-bold" data-id="element-4">
              Loading...
            </p>
          </div>
        </div>} data-id="element-0">
      <SalesPage data-id="element-5" />
    </Suspense>;
}